<template>
    <div class="page page--home layout">
        <div class="layout__header">
            <div class="logo"></div>
            <div class="message-box">
                <i v-if="hasMsg > 0" class="message-box__point"></i>
                <a href="javascript:void(0);" @click="goMessage(2)" class="message-box__icon"></a>
            </div>
        </div>
        <div class="layout__body">
			<Swiper swipeid="swipe" ref="swiper" effect="slide">
				<div v-for="(banner, index) in bannerList" :key="index" class="swiper-slide" slot="swiper-con" >
					<a :href="banner.uri" class="swiper__slide--img">
						<img class="banner__img" :src="banner.img" alt="">
					</a>
				</div>
			</Swiper>
			<!-- <div v-if="msgList.length !== 0" style="margin-bottom:5px;"> -->
			<div v-if="hasMsg > 0" style="margin-bottom:5px;">
				<div style="background-color:lightblue;line-height:2.6em;width:16em;margin:auto;border-radius:8px;position:relative" @click="goMessage(2)">
					<div style="position:absolute;height:1em;width:1em;background-color:#d01f1f;border-radius:0.6em;top:0.7em;left:3em">
					</div>
					<!-- <span style="margin-left:4.5em;">您有{{msgList.length}}条未读消息</span> -->
					<span style="margin-left:4.5em;">您有{{hasMsg}}条未读消息</span>
				</div>
			</div>
			<ColumnGroup
				:columnList="columnList"
				@on-read="readChannel">
			</ColumnGroup>
        </div>
    </div>
</template>
<script>
// @ is an alias to /src
import Swiper from '@/components/Swiper.vue';
import ColumnGroup from '@/components/ColumnGroup.vue';
import API from '@/api.js';
export default {
	name: 'home',
	data () {
		return {
			hasMsg: 0, // 是否存在未读消息
			// 轮播图列表数据
			bannerList: [],
			// 栏目列别数据
			columnList: []
			// msgList: []
		};
	},
	methods: {
		getBanner () {
			API.getBannerList().then((res) => {
				if (res.data.code === 200) {
					this.bannerList = res.data.data.list;
				}
			});
		},
		getColumn () {
			API.getColumnList().then((res) => {
				if (res.data.code === 200) {
					this.columnList = res.data.data.list;
				}
			});
		},
		readChannel (channelid, uri) {
			if (!uri) {
				return false;
			}
			API.read(channelid).then((res) => {
				if (uri) {
					window.location.href = uri;
				}
			});
		},
		// getMsgReadStatus () {
		// 	API.readStatus().then((res) => {
		// 		if (res.data.code === 200) {
		// 			this.hasMsg = res.data.data.num;
		// 		}
		// 	});
		// },
		goMessage (type) {
			if (type === 1) {
				this.$router.push('/message');
			} else {
				this.$router.push('/mljy_message');
			}
		},
		setWechat () {
			let _self = this;
			API.getWechatAssign().then((res) => {
				let data = res.data.data;
				_self.$wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
					timestamp: data.timestamp, // 必填，生成签名的时间戳
					nonceStr: data.nonceStr, // 必填，生成签名的随机串
					signature: data.signature, // 必填，签名，见附录1
					jsApiList: ['hideOptionMenu', 'showOptionMenu']
				});
				_self.$wx.ready(function () {
					_self.$wx.showOptionMenu();
				});
				_self.$wx.showOptionMenu();
			});
		},
		getMsgList () {
			const _self = this;
			API.getMsgList(1, 1, 1000).then((res) => {
				// _self.msgList = res.data;
				_self.hasMsg = res.data.length;
				// console.log('Msg list: ', _self.msgList);
			});
		}
	},
	components: {
		Swiper,
		ColumnGroup
	},
	created () {
	},
	mounted () {
		this.getBanner();
		this.getColumn();
		// this.getMsgReadStatus();
		this.setWechat();
		this.$wx.showOptionMenu();
		this.getMsgList();
	}
};
</script>
